import { useLoading } from '@genial/components';
import { ErrorListResponse, instanceOfErrorListResponse, Service } from '@genial/services';
import { CustomerEntity, EquityOrderChangeRequest } from '@genial/services/dist/models';
import { useNavigation } from '@react-navigation/native';

import { useToastCreator } from '../../../../../hooks/useToastCreator';
import {
  FundOrderBuySuccessResponse,
  SignedInNavigationScreenNavigationProp,
} from '../../../../../routes/types';
import { defaultErrorMessage, screenName } from '../constants';

interface UseOrderProps {
  customer?: CustomerEntity;
  equityOperationType: string;
}

export const useOrder = ({ customer, equityOperationType }: UseOrderProps) => {
  const { showToast, showToastFromError } = useToastCreator('update-order-toast');
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { hide, show } = useLoading();

  const handleUpdateEquityOrder = async (equityOrderChangeRequest: EquityOrderChangeRequest) => {
    try {
      show({
        title: 'Aguarde estamos atualizando sua ordem.',
        description: 'Este processo pode levar alguns segundos, não saia desta pagina.',
      });

      const { data } = await Service.Equities.V1.putOrdersUpdate({
        screenName,
        equityOrderChangeRequest,
      });

      const params = {
        type: 'Equity',
        ...data,
        customer,
        equityOperationType,
      } as unknown as FundOrderBuySuccessResponse;

      navigate('Resume', params);
    } catch (error) {
      if (instanceOfErrorListResponse(error as any)) {
        (error as ErrorListResponse).errors?.forEach((errorItem) => showToastFromError(errorItem));
        return;
      }

      showToast(...defaultErrorMessage);
    } finally {
      hide();
    }
  };

  return { handleUpdateEquityOrder };
};
